import { getReadonlyListItemId } from '@interxfi/app-components/components/readonly-list/util';
import type { ReadonlyListItemRecord } from '@interxfi/design-system/components/list/readonly/item/readonly-list-item';
import type { IxcBillingV1CorrespondentAccount } from '@interxfi/types';
import { getRegistrationAccountDetailPath } from '../registration/account/registration-account-routing';

export function getBillingCorrespondentAccountListItems(data: IxcBillingV1CorrespondentAccount | undefined, prefix = '') {
  return {
    accountId: getReadonlyListItemId(`${prefix}accountId`, 'Account ID', data?.accountId, getRegistrationAccountDetailPath(data?.accountId)),
  } as const satisfies ReadonlyListItemRecord;
}
